export function returnTokenized(string) {
    return (string.match(/"[^"]+"|\S+/g) || []).flatMap(token =>
        token.startsWith('"') && token.endsWith('"')
            ? [token.slice(1, -1)] // Quoted token as-is
            : token.split(/[^\w]+/).filter(Boolean) // Split unquoted tokens on non-word chars
    );
}

export function removeAccents(str: string): string {
    return str.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
}

const FOLDER_FILTER_FIELDS = ['Category', 'Industry List', 'Year', 'Genre'];

export function applyFilter(scripts, filters) {
    let filtered = scripts;

    // Iterate filters and only apply the ones that exist in the filters object
    for (const field in filters) {
        if (filters[field] === undefined) { continue; } // Filter is present but undefined, skip it
        if (field.includes("_includeEmpty")) { continue; } // Skip includeEmpty fields

        // Folder-based tag filters: Category/Industry List/Year → check s.tags array
        if (FOLDER_FILTER_FIELDS.includes(field) && typeof filters[field] === 'string' && filters[field] !== field) {
            const value = (filters[field] as string).replace(/"/g, '').trim();
            if (value) filtered = filtered.filter(s => (s.tags || []).includes(value));
            continue;
        }

        // Pilot tag filter
        if (field === 'Pilot' && filters[field]) {
            filtered = filtered.filter(s => (s.tags || []).includes('Pilot'));
            continue;
        }

        // Check for string filters and apply them
        if (filters[field] !== "" && typeof filters[field] === "string") {
            filtered = filtered.filter((s) => {
                const tokenizedFilter = returnTokenized(filters[field]);
                return (
                    filters[field] === field || // The default value is set, no filtering
                    (
                        s[field] !== null &&
                        s[field] !== undefined &&
                        typeof s[field] === "string" &&
                        tokenizedFilter.every(t =>
                            removeAccents(s[field].toLowerCase()).includes(removeAccents(t.toLowerCase()))
                        )

                    )
                );
            })
        }

        // Check for date range filters and apply them
        if (filters[field] !== null && typeof filters[field] === "object" && typeof filters[field][0] === "number" && field.includes("Date")) {
            filtered = filtered.filter((s) => {
                const filteredDate = s[field]
                    ? new Date(s[field]).getTime()
                    : NaN;
                return (
                    (isNaN(filteredDate) && filters[field + "_includeEmpty"]) ||
                    ((filteredDate >= filters[field][0]) && (filteredDate <= filters[field][1]))
                );
            });
        }

        // Tags filter: selected tags array → scripts must have at least one matching tag
        if (field === 'tags' && Array.isArray(filters[field]) && filters[field].length > 0) {
            filtered = filtered.filter((s) =>
                filters[field].some((tag: string) => (s.tags || []).includes(tag))
            );
        }

        // Check for other array filters (i.e. Favorites) and apply them
        if (field !== 'tags' && filters[field] !== null && typeof filters[field] === "object" && typeof filters[field][0] === "string") {
            filtered = filtered.filter((s) => {
                // Returns true if any of the values in the filter array are present in a field's value
                return (filters[field].some((value) => Object.values(s).includes(value)))
            });
        }
    }
    return (filtered);
};